import React, { useState, useContext } from "react";
import { Paper, TableBody, InputAdornment, TableRow, TableCell, Input } from "@material-ui/core";
import useTable from "../../hooks/useTable";
import { AdminContext } from "../../context/DeliveryContext";
import ModalView from "../modal/AdminFormModal";
import _ from "lodash";
import { Search } from "@material-ui/icons";
import AlertDialog from "../common/AlertDialog";
import { AlertMessage } from "../../constants/AlertMessage";
import { TableClassname } from "../../constants/Text";
import "../../styles/deliverylist.scss";

const headCells = [
  { id: "actions", label: "Actions", disableSorting: true },
  { id: "name", label: "Item Name" },
];

export default function DataGriddle() {
  const { itemList, deleteItem, onUpdateItem, selectedList } = useContext(AdminContext);
  const [modalView, setView] = useState({});
  const [alert, setAlert] = useState({});
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { Delete } = AlertMessage;

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting, isVisible } = useTable(
    itemList,
    headCells,
    filterFn,
    selectedList,
    TableClassname.DELIVERY_TABLE
  );

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else return items.filter((x) => x.name.toLowerCase().includes(_.toLower(target.value)));
      },
    });
  };

  return (
    <>
      <Paper className="listPageContent">
        <Input
          type="search"
          disableUnderline={true}
          className="listSearchInput"
          startAdornment={
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          }
          onChange={handleSearch}
        />
        {isVisible() ? (
          <>
            <TblContainer>
              <TblHead />
              <TableBody id={"table_container"}>
                {recordsAfterPagingAndSorting().map((item) => (
                  <TableRow key={item._id}>
                    <TableCell>
                      {
                        <span>
                          {" "}
                          <i
                            style={{ marginRight: "5px", cursor: "pointer" }}
                            className="material-icons"
                            onClick={(e) => {
                              e.preventDefault();
                              setView(item);
                            }}>
                            mode_edit
                          </i>
                          <i
                            style={{ cursor: "pointer" }}
                            className="material-icons"
                            onClick={(e) => {
                              e.preventDefault();
                              setAlert(item);
                            }}>
                            delete
                          </i>
                        </span>
                      }
                    </TableCell>
                    <TableCell>{item.name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </TblContainer>
            <TblPagination />
          </>
        ) : (
          <div style={{ marginTop: "24px", paddingBottom: "24px" }}>No results found</div>
        )}
      </Paper>
      {!_.isEmpty(modalView) ? (
        <ModalView
          item={modalView}
          show={true}
          onComplete={(newItem) => {
            onUpdateItem(newItem);
            setView({});
          }}
          onClose={(e) => {
            setView({});
          }}
        />
      ) : null}
      {!_.isEmpty(alert) ? (
        <AlertDialog
          alertMessage={Delete + _.get(alert, "name")}
          isAlert={true}
          onClose={() => {
            setAlert({});
          }}
          onCancel={() => {
            setAlert({});
          }}
          onConfirm={() => {
            deleteItem(_.get(alert, "name"), _.get(alert, "_id", ""));
          }}
        />
      ) : null}
    </>
  );
}
